import { Component, OnInit, ElementRef, Renderer2, OnDestroy, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, User, CaptchaResponse, UserInfo } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { AssenzeService } from '../service/assenze.service';
import { UserService } from '../service/user.service';
import { SelectItem } from 'primeng/primeng';
import { UserCalendarService } from 'app/service/userCalendar.service';
import { Subscription } from 'rxjs';
import { AppConstants } from '../core/app.constants';



declare var $: any;


@Component({
  selector: 'app-detail-assenza-malattia',
  templateUrl: './detail-assenza-malattia.component.html',
  styleUrls: ['./detail-assenza-malattia.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class DetailAssenzaMalattiaComponent extends BaseComponent implements OnInit, OnDestroy {
  static DIALOG_MALATTIA_ID: string = "detailAssenzeMalattiaDialog";
  userContext: UserContext;
  infoMessage: string;
  errorMessage: string;
  private subscriptions: Subscription[] = [];

  userSelected: SelectItem = null;
  filterUsers: SelectItem[] = [];
  filteredUsers: SelectItem[] = [];

  numCertificato: string = null;
  fromDate: string = null;
  toDate: string = null;

  userInfo: UserInfo = new UserInfo();
  inserimento: boolean = false;
  mostraRiepilogo: boolean = false;
  completed: boolean = true;
  controllo2Value: string = '';

  private captchaWidgetInstance: any;
  private scriptFallback?: HTMLScriptElement;
  private captchaScriptLoadPromise?: Promise<void>;
  private captchaRequestToken: number = 0;

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private assenzeService: AssenzeService,
    private userService: UserService,
    private el: ElementRef,
    private renderer: Renderer2,
    private zone: NgZone,
    private userCalendarService: UserCalendarService) {
    super(authAccess, router, messageProvider);
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.init();

      const statusSub = this.assenzeService.getAssenzeMalattiaDetailStatus().subscribe(
        operation => {
          if (operation.status == "open") {
            this.loadCaptchaWidget();
            $("#" + DetailAssenzaMalattiaComponent.DIALOG_MALATTIA_ID).modal({ backdrop: 'static', keyboard: false });
          }
        }
      );
      this.subscriptions.push(statusSub);
    }
  }

  private init() {
    const userInfoSub = this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
      result => {
        this.userInfo = result;
        if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
          this.userInfo.managedUsers.push(this.userContext.userId);
        }
        if (this.userInfo.admin) {
          const usersSub = this.userService.getUsers(this.userContext.srmToken).subscribe(
            results => {
              for (var i = 0; i < results.users.length; ++i) {
                var current: User = results.users[i];
                this.filterUsers.push({ label: current.fullname, value: current.id });
              }
            },
            error => {
              this.handleError(error);
            }
          );
          this.subscriptions.push(usersSub);
        }
      },
      error => {
        this.handleError(error);
      });
    this.subscriptions.push(userInfoSub);
  }

  reset() {
    this.inserimento = false;
    this.mostraRiepilogo = false;
    this.userSelected = null;
    this.numCertificato = null;
    this.errorMessage = null;
    this.infoMessage = null;
    this.controllo2Value = '';
  }

  filterUser(event) {
    this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
  }

  shortcutHandler(event) {
    if (event.keyCode == 27) {
      this.close();
    }
  }

  verificaCertificato() {
    if (this.userInfo.admin && !this.userSelected) {
      this.errorMessage = "Inserire l'utente";
      return;
    }
    if (!this.numCertificato) {
      this.errorMessage = "Inserire il numero del certificato";
      return;
    }
    this.completed = false;
    this.errorMessage = null;
    const sub = this.assenzeService
      .inserisciAssenzaPerMalattia(
        this.userContext.srmToken,
        this.numCertificato,
        this.userSelected ? this.userSelected.value : -1,
        this.controllo2Value,
        this.inserimento
      )
      .subscribe(
        result => {
          this.mostraRiepilogo = true;
          this.inserimento = true;
          this.fromDate = result.fromDateCM;
          this.toDate = result.toDateCM;
          this.loadCaptchaWidget();
        },
        error => {
          this.completed = true;
          this.loadCaptchaWidget();
          this.errorMessage = this.retrieveError(error);
        }
      );
    this.subscriptions.push(sub);
  }

  inserisciAssenza() {
    if (this.userInfo.admin && !this.userSelected) {
      this.errorMessage = "Inserire l'utente";
      return;
    }
    this.completed = false;
    this.errorMessage = null;
    const sub = this.assenzeService
      .inserisciAssenzaPerMalattia(
        this.userContext.srmToken,
        this.numCertificato,
        this.userSelected ? this.userSelected.value : -1,
        this.controllo2Value,
        this.inserimento
      ).subscribe(
        result => {
          this.completed = true;
          let msg = "Inserimento eseguito correttamente";
          this.messageProvider.notifyMessage(msg);
          this.close();
          this.assenzeService.fireRefreshEvent();
        },
        error => {
          this.completed = true;
          this.errorMessage = this.retrieveError(error);
        });
    this.subscriptions.push(sub);
  }

  close() {
    this.reset();
    $("#" + DetailAssenzaMalattiaComponent.DIALOG_MALATTIA_ID).modal("hide");
  }


  private loadCaptchaWidget(): void {
    this.completed = false;
    this.errorMessage = null;

    const captchaDiv = this.el.nativeElement.querySelector('#newCaptcha');
    if (!captchaDiv) {
      console.error('Elemento #newCaptcha non trovato nel DOM');
      this.completed = true;
      return;
    }

    const currentToken = ++this.captchaRequestToken;

    if (this.captchaWidgetInstance) {
      this.captchaWidgetInstance.destroy();
      this.captchaWidgetInstance = null;
    }

    const existingWidget = captchaDiv.querySelector('.frc-captcha');
    if (existingWidget) {
      this.renderer.removeChild(captchaDiv, existingWidget);
    }
    this.controllo2Value = '';

    const widgetDiv: HTMLElement = this.renderer.createElement('div');
    this.renderer.addClass(widgetDiv, 'frc-captcha');
    this.renderer.setAttribute(widgetDiv, 'data-sitekey', 'FCMQ86GK42FSDB1R');
    this.renderer.setAttribute(widgetDiv, 'data-lang', 'it');
    this.renderer.setAttribute(widgetDiv, 'data-puzzle-endpoint', 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle');
    this.renderer.appendChild(captchaDiv, widgetDiv);

    this.ensureCaptchaScriptLoaded(captchaDiv)
      .then(() => {
        if (currentToken !== this.captchaRequestToken) {
          return;
        }
        this.initCaptchaWidget(widgetDiv);
      })
      .catch(() => {
        if (currentToken !== this.captchaRequestToken) {
          return;
        }
        this.completed = true;
        this.errorMessage = "Impossibile caricare il captcha. Riprova più tardi.";
      });
  }

  private ensureCaptchaScriptLoaded(captchaDiv: HTMLElement): Promise<void> {
    if (this.captchaScriptLoadPromise) {
      return this.captchaScriptLoadPromise;
    }

    this.captchaScriptLoadPromise = new Promise<void>((resolve, reject) => {
      const script: HTMLScriptElement = this.renderer.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.19/widget.min.js';
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => {
        console.error('Errore nel caricamento del widget captcha');
        reject(new Error('captcha-script-load-failed'));
      };
      this.scriptFallback = script;
      this.renderer.appendChild(captchaDiv, script);
    }).catch(err => {
      this.captchaScriptLoadPromise = undefined;
      throw err;
    });

    return this.captchaScriptLoadPromise;
  }

  private initCaptchaWidget(widgetDiv: HTMLElement): void {
    const fc = (window as any).friendlyChallenge;
    if (!fc) {
      console.error('Libreria friendlyChallenge non disponibile');
      this.completed = true;
      this.errorMessage = "Impossibile inizializzare il captcha.";
      return;
    }

    this.captchaWidgetInstance = new fc.WidgetInstance(widgetDiv, {
      doneCallback: (solution: string) => {
        this.zone.run(() => {
          this.controllo2Value = solution;
          this.completed = true;
        });
      },
      errorCallback: (error: any) => {
        this.zone.run(() => {
          console.error('Errore captcha friendly-challenge:', error);
          this.completed = true;
          this.errorMessage = "Errore nella verifica del captcha. Riprova.";
        });
      }
    });
    this.captchaWidgetInstance.start();
  }

  ngOnDestroy(): void {
    this.captchaRequestToken++;

    if (this.captchaWidgetInstance) {
      this.captchaWidgetInstance.destroy();
      this.captchaWidgetInstance = null;
    }
    if (this.scriptFallback) {
      this.scriptFallback.remove();
    }
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/detail-assenza-malattia/detail-assenza-malattia.component.ts